/* Bella Ballou: fælles beløbshjælper. Omregner DKK-beløb (ører) til kundens valuta med Shopify.currency.rate.
   Bruges af fri fragt-baren og Levering-fanen. Markup: <span class="bb-money" data-bb-dkk="<øre>">…</span> */
if (!window.BbMoney) {
  window.BbMoney = {
    get rate() {
      const rate = parseFloat(window.Shopify && window.Shopify.currency && window.Shopify.currency.rate);
      return rate > 0 ? rate : 1;
    },

    get currency() {
      return (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'DKK';
    },

    // Formaterer et beløb i øre/cents (allerede i kundens valuta).
    format(cents) {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(cents);
      }
      const locale = document.documentElement.lang || undefined;
      const amount = cents / 100;
      try {
        return new Intl.NumberFormat(locale, {
          style: 'currency',
          currency: this.currency,
          minimumFractionDigits: Number.isInteger(amount) ? 0 : 2,
        }).format(amount);
      } catch (error) {
        return amount.toFixed(2);
      }
    },

    // Omregner alle .bb-money[data-bb-dkk] under root. Røres ikke, når kunden handler i DKK.
    convertAll(root) {
      if (this.currency === 'DKK') return;
      (root || document).querySelectorAll('.bb-money[data-bb-dkk]').forEach((element) => {
        const dkk = parseInt(element.dataset.bbDkk, 10);
        if (isNaN(dkk) || element.dataset.bbConverted) return;
        element.textContent = this.format(Math.round(dkk * this.rate));
        element.dataset.bbConverted = 'true';
        element.removeAttribute('data-bb-pending');
      });
    },

    // Dawn genrenderer produktsektionen (fx ved variantskift) med server-HTML i DKK: omregn nye beløb igen.
    observe() {
      if (this.currency === 'DKK' || this.observer || !document.body) return;
      this.observer = new MutationObserver((mutations) => {
        if (mutations.some((mutation) => mutation.addedNodes.length)) this.convertAll(document);
      });
      this.observer.observe(document.body, { childList: true, subtree: true });
    },
  };

  const init = () => {
    window.BbMoney.convertAll(document);
    window.BbMoney.observe();
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
}
